export default function (context, {cb}) {
    context.commit('clean');
    context.commit('loading', true);
    axios({
        method: 'GET',
        url: '/tourclient/api/wiki/get',
    }).then(({data}) => {
        context.commit('loading', false);
        context.commit('set', data);
    }).catch(data => {
        context.commit('loading', false);
        context.dispatch('error', data, {root: true});
    });
}
